import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-216f9ec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-row" }
const _hoisted_2 = { class: "input-label" }
const _hoisted_3 = {
  key: 0,
  class: "primary"
}
const _hoisted_4 = {
  key: 0,
  class: "input-label"
}
const _hoisted_5 = { class: "section-top" }
const _hoisted_6 = { class: "table-header" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_9 = { class: "group-list" }
const _hoisted_10 = {
  key: 0,
  class: "empty-group"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "group-row-leading" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "username long-name"
}
const _hoisted_16 = {
  key: 1,
  class: "username long-name"
}
const _hoisted_17 = { class: "email long-name" }
const _hoisted_18 = { class: "add-btn" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "row-divider mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chip = _resolveComponent("chip")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_AvatarCircle = _resolveComponent("AvatarCircle")!
  const _component_Vue3Popper = _resolveComponent("Vue3Popper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("common.requiredText")), 1))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
      ]),
      (_ctx.limit)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.selectedItems.length) + " / " + _toDisplayString(_ctx.limitNumber), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      ref: "group",
      class: _normalizeClass(["group-body", { focused: _ctx.inputFocused }]),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputFocused = true))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "group-select",
            style: _normalizeStyle(_ctx.permissions.length == 0 ? 'width:100%;' : 'width: 70%;')
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItems, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "select-tag"
              }, [
                (_ctx.itemTypes == 'GroupUser')
                  ? (_openBlock(), _createBlock(_component_chip, {
                      key: 0,
                      avatar: 
                item.name
                  ? null
                  : item.profilePicture
                  ? _ctx.getFilePathFromUrl(item.profilePicture)
                  : require('icons/default-avatar.svg')
              ,
                      text: item.name ? item.name : item.email,
                      "can-remove": true,
                      class: _normalizeClass({ 'mr-1 mb-1': !_ctx.isMobile }),
                      onOnRemove: ($event: any) => (_ctx.removeItem(item))
                    }, null, 8, ["avatar", "text", "class", "onOnRemove"]))
                  : (_ctx.itemTypes == 'Group')
                    ? (_openBlock(), _createBlock(_component_chip, {
                        key: 1,
                        avatar: item.avatar ? require('icons/default-avatar.svg') : '',
                        text: item.name ? item.name : item.email,
                        "can-remove": true,
                        class: _normalizeClass({ 'mr-1 mb-1': !_ctx.isMobile }),
                        onOnRemove: ($event: any) => (_ctx.removeItem(item))
                      }, null, 8, ["avatar", "text", "class", "onOnRemove"]))
                    : (_openBlock(), _createBlock(_component_chip, {
                        key: 2,
                        avatar: item.avatar ? require('icons/default-avatar.svg') : '',
                        text: 
                item.lastName || item.firstName
                  ? item.lastName + ' ' + item.firstName
                  : item.email
              ,
                        "can-remove": true,
                        class: _normalizeClass({ 'mr-1 mb-1': !_ctx.isMobile }),
                        onOnRemove: ($event: any) => (_ctx.removeItem(item))
                      }, null, 8, ["avatar", "text", "class", "onOnRemove"]))
              ]))
            }), 128)),
            _withDirectives(_createElementVNode("input", {
              class: "group-title",
              style: _normalizeStyle({
              marginTop: `${
                (_ctx.selectedItems.length != 0 && _ctx.isMobile) ||
                (_ctx.defaultDropdrownOption && _ctx.isMobile)
                  ? 5
                  : 0
              }px`,
            }),
              placeholder: _ctx.searchHint,
              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.searchQueryChange && _ctx.searchQueryChange(...args))),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.isCreateTag ? _ctx.createTag() : ''), ["enter"]))
            }, null, 44, _hoisted_7), [
              [
                _vModelText,
                _ctx.searchQuery,
                void 0,
                { trim: true }
              ]
            ])
          ], 4),
          (_ctx.permissions.length != 0)
            ? (_openBlock(), _createBlock(_component_dropdown, {
                key: 0,
                class: "dropdown",
                options: _ctx.permissions,
                "default-option": _ctx.selectedPermission,
                onOnChange: _cache[3] || (_cache[3] = (id) => _ctx.changePermission(id)),
                name: "permissionsDropdown"
              }, null, 8, ["options", "default-option"]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.items.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("teamMember.emptyGroup")), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["group-row", { selected: _ctx.isSelectedItem(item) }]),
                onClick: ($event: any) => (!_ctx.isSelectedItem(item) ? _ctx.selectItem(item) : null)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([{ selected: _ctx.isSelectedItem(item) }, "single-row"])
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.itemTypes == 'GroupUser' && !item.name)
                      ? (_openBlock(), _createBlock(_component_AvatarCircle, {
                          key: 0,
                          avatar: 
                item.profilePicture
                  ? _ctx.getFilePathFromUrl(item.profilePicture)
                  : require('icons/default-avatar.svg')
              ,
                          alt: "avatar",
                          class: "icon"
                        }, null, 8, ["avatar"]))
                      : (_ctx.itemTypes == 'GroupUser')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: require('icons/primary-view.svg'),
                            alt: "avatar",
                            class: "icon"
                          }, null, 8, _hoisted_13))
                        : (_ctx.itemTypes == 'User')
                          ? (_openBlock(), _createBlock(_component_AvatarCircle, {
                              key: 2,
                              avatar: 
                item.profilePicture
                  ? _ctx.getFilePathFromUrl(item.profilePicture)
                  : require('icons/default-avatar.svg')
              ,
                              alt: "avatar",
                              class: "icon"
                            }, null, 8, ["avatar"]))
                          : (_ctx.itemTypes == 'Group')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 3,
                                src: require('icons/primary-view.svg'),
                                alt: "avatar",
                                class: "icon"
                              }, null, 8, _hoisted_14))
                            : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      (item.name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(item.name), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(item.lastName + " " + item.firstName), 1)),
                      (item.email != null)
                        ? (_openBlock(), _createBlock(_component_Vue3Popper, {
                            key: 2,
                            content: item.email
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(item.email), 1)
                            ]),
                            _: 2
                          }, 1032, ["content"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", { class: "company-tag" }, _toDisplayString(item.companyName), 513), [
                    [_vShow, _ctx.isShowCompany]
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("img", {
                      src: require('icons/add.svg'),
                      alt: "add button"
                    }, null, 8, _hoisted_19)
                  ])
                ], 2),
                (index != _ctx.items.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_11))
            }), 128))
      ])
    ], 2)
  ], 64))
}